import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { CommonButton } from '@/components/ui/common-button';

const DeleteUserDialog = ({ open, onOpenChange, user, onDeleteUser, isTransporter }) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    setIsDeleting(true);
    try {
      await onDeleteUser(user.id);
      onOpenChange(false);
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>{isTransporter ? 'Delete Driver' : 'Delete User'}</DialogTitle>
          <DialogDescription>
            Are you sure you want to delete <span className="font-semibold">{user?.name}</span>? 
            This action cannot be undone.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:gap-0">
          <CommonButton 
            type="button" 
            variant="outline" 
            onClick={() => onOpenChange(false)}
            disabled={isDeleting}
          >
            Cancel
          </CommonButton>
          <CommonButton 
            type="button" 
            variant="destructive" 
            onClick={handleDelete}
            disabled={isDeleting}
          >
            {isDeleting ? (isTransporter ? 'Deleting Driver...' : 'Deleting User...') : (isTransporter ? 'Delete Driver' : 'Delete User')}
          </CommonButton>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteUserDialog;